// extracted by mini-css-extract-plugin
export default {"root":"mbnug23e2mreFPyBbPng"};